import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-598a96d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["alt"]
const _hoisted_2 = ["alt"]
const _hoisted_3 = { class: "text-card absolute left-0 top-0 flex flex-col justify-between w-full h-full md:w-1/2 lg:w-1/3 xl:w-[578px]" }
const _hoisted_4 = { class: "absolute left-0 top-0 flex flex-col justify-between w-full h-full md:w-1/2 lg:w-1/3 xl:w-[578px]" }
const _hoisted_5 = ["alt"]
const _hoisted_6 = ["alt"]
const _hoisted_7 = { class: "text-card absolute left-0 top-0 flex flex-col justify-between w-full h-full md:w-1/2 lg:w-1/3 xl:w-[578px]" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-1/2 md:h-1/2" }, null, -1))
const _hoisted_9 = { class: "flex justify-end flex-col h-1/2 md:h-1/2 mb-20 sm:mb-[120px] 2xl:mb-150px ml-5 sm:ml-50px mr-30px" }

import { MJPSection, MJPSectionData } from './types'
import SectionBase from '../general/SectionBase.vue'
import SectionPage from '../general/SectionPage.vue'
import TextCard from '../general/TextCard.vue'
import useLanguage from '@/composables/useLanguage'
import useImageLoad from '@/composables/useImageLoad'
import ResponsiveBackgroundImage from '../general/ResponsiveBackgroundImage.vue'
import WatershedDiagram from '@/assets/svg/WatershedDiagram.vue'
import WatershedDiagramMobile from '@/assets/svg/WatershedDiagramMobile.vue'
import ComptonCreekDiagram from '@/assets/svg/ComptonCreekDiagram.vue'

interface Props {
  sectionData: MJPSectionData
  currentSection: MJPSection
  currentSectionHasLoaded: boolean
  currentPage: number
  forward: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WatershedContext',
  props: {
    sectionData: null,
    currentSection: null,
    currentSectionHasLoaded: { type: Boolean },
    currentPage: null,
    forward: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  sectionData: MJPSectionData
  currentSection: MJPSection
  currentSectionHasLoaded: boolean
  currentPage: number
  forward: boolean
}


const sectionText = useLanguage('watershedContext')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SectionBase, {
    class: "bg-aquafer-tint20",
    thisSection: props.sectionData.section,
    currentSection: props.currentSection,
    currentSectionHasLoaded: props.currentSectionHasLoaded,
    currentPage: props.currentPage,
    forward: props.forward,
    position: props.sectionData.focalPoint
  }, {
    default: _withCtx(() => [
      _createVNode(SectionPage, {
        id: `${props.sectionData.section}-1`,
        class: "flex items-end justify-start",
        style: _normalizeStyle({
          opacity:
            props.currentSection == props.sectionData.section &&
            props.currentPage == 0
              ? 1
              : 0,
        })
      }, {
        default: _withCtx(() => [
          _createVNode(WatershedDiagram, {
            class: "absolute hidden sm:block left-0 top-0 w-full h-full",
            alt: _unref(sectionText).watershedDiagramAlt
          }, null, 8, ["alt"]),
          _createElementVNode("img", {
            id: "watersheda",
            class: "absolute hidden sm:block left-0 max-w-none top-0 w-full h-full object-contain object-right-top",
            src: "/images/mjp/watersheda.gif",
            onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(useImageLoad) && _unref(useImageLoad)(...args))),
            alt: _unref(sectionText).watershedAnimationAlt
          }, null, 40, _hoisted_1),
          _createVNode(WatershedDiagramMobile, {
            class: "absolute block sm:hidden left-0 -top-[14%] md:top-0 w-full h-[103%]",
            alt: _unref(sectionText).watershedDiagramAlt
          }, null, 8, ["alt"]),
          _createElementVNode("img", {
            id: "watersheda-mobile",
            class: "absolute block sm:hidden left-0 max-w-none -top-[14%] w-full h-[103%] object-contain object-center-top",
            src: "/images/mjp/watersheda-mobile.gif",
            onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(useImageLoad) && _unref(useImageLoad)(...args))),
            alt: _unref(sectionText).watershedAnimationAlt
          }, null, 40, _hoisted_2),
          _createVNode(TextCard, {
            class: "absolute !hidden xs:!block left-5 sm:left-50px bottom-100px sm:bottom-150px 2xl:bottom-200px",
            text: _unref(sectionText).location,
            enclosed: false,
            textAlign: "text-left",
            size: "text-bodyXl sm:text-body2xl 2xl:text-body3xl max-w-sm sm:max-w-md 2xl:max-w-xl"
          }, null, 8, ["text"]),
          _createVNode(TextCard, {
            class: "absolute !block xs:!hidden bottom-24",
            text: _unref(sectionText).location,
            enclosed: true
          }, null, 8, ["text"])
        ]),
        _: 1
      }, 8, ["id", "style"]),
      _createVNode(SectionPage, {
        id: `${props.sectionData.section}-2`,
        class: "flex bg-slateGray",
        style: _normalizeStyle({
          opacity:
            props.currentSection == props.sectionData.section &&
            props.currentPage >= 1 &&
            props.currentPage <= 2
              ? 1
              : 0,
        })
      }, {
        default: _withCtx(() => [
          _createVNode(ResponsiveBackgroundImage, {
            id: "watershedContext-bg",
            dir: "mjp",
            sm: "watershedContext-bg-sm.jpg",
            md: "watershedContext-bg-md.jpg",
            lg: "watershedContext-bg-lg.jpg",
            alt: "sectionText.altText",
            class: "hidden md:block md:left-1/2 lg:left-1/3 xl:left-[578px]",
            isActive: true
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ComptonCreekDiagram, {
              class: "w-full md:max-h-[400px] opacity-0",
              alt: _unref(sectionText).comptonCreekDiagramAlt
            }, null, 8, ["alt"]),
            _createVNode(TextCard, {
              text: _unref(sectionText).before,
              class: "ml-5 sm:ml-50px mr-30px mb-20 sm:mb-[120px] 2xl:mb-150px",
              textAlign: "text-left",
              enclosed: false,
              variant: "light",
              size: "text-bodyXl xl:text-body2xl 2xl:text-body3xl md:max-w-md 2xl:max-w-xl"
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(ComptonCreekDiagram, {
              class: "w-full max-h-[55vh] md:max-h-[400px]",
              alt: _unref(sectionText).comptonCreekDiagramAlt
            }, null, 8, ["alt"]),
            _createElementVNode("img", {
              id: "watershedb",
              class: "absolute w-full max-h-[55vh] md:max-h-[400px] object-contain",
              style: _normalizeStyle({
              aspectRatio: 578 + '/' + 637,
              opacity:
                props.currentSection == props.sectionData.section &&
                props.currentPage == 1
                  ? 1
                  : 0,
            }),
              src: "/images/mjp/watershedb.gif",
              onLoad: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(useImageLoad) && _unref(useImageLoad)(...args))),
              alt: _unref(sectionText).comptonCreekBeforeAnimationAlt
            }, null, 44, _hoisted_5),
            _createElementVNode("img", {
              id: "watershedc",
              class: "absolute w-full max-h-[55vh] md:max-h-[400px] object-contain",
              style: _normalizeStyle({
              aspectRatio: 578 + '/' + 637, // not the actual aspect ratio, not sure why this works
              opacity:
                props.currentSection == props.sectionData.section &&
                props.currentPage == 2
                  ? 1
                  : 0,
            }),
              src: "/images/mjp/watershedc.gif",
              onLoad: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(useImageLoad) && _unref(useImageLoad)(...args))),
              alt: _unref(sectionText).comptonCreekAfterAnimationAlt
            }, null, 44, _hoisted_6)
          ])
        ]),
        _: 1
      }, 8, ["id", "style"]),
      _createVNode(SectionPage, {
        id: `${props.sectionData.section}-3`,
        class: "flex",
        style: _normalizeStyle({
          opacity:
            props.currentSection == props.sectionData.section &&
            props.currentPage == 2
              ? 1
              : 0,
        })
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(TextCard, {
                text: _unref(sectionText).today,
                class: "mb-8 xl:mb-14",
                textAlign: "text-left",
                enclosed: false,
                variant: "light",
                size: "font-bold text-bodyXl xl:text-body2xl 2xl:text-body3xl md:max-w-md 2xl:max-w-xl"
              }, null, 8, ["text"]),
              _createVNode(TextCard, {
                text: _unref(sectionText).firstStop,
                textAlign: "text-left",
                enclosed: false,
                variant: "light",
                size: "text-bodyXl xl:text-body2xl 2xl:text-body3xl md:max-w-md 2xl:max-w-xl"
              }, null, 8, ["text"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["id", "style"])
    ]),
    _: 1
  }, 8, ["thisSection", "currentSection", "currentSectionHasLoaded", "currentPage", "forward", "position"]))
}
}

})